// features/userListSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../auth/api";
import { alertError, alertSuccess } from "../components/Alert";

// Async thunk to fetch user list
export const fetchUserList = createAsyncThunk(
  "userList/fetchUserList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/account/panel/user");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateUserList = createAsyncThunk(
  "userList/updateUserList",
  async (updatedUserList, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        "/account/panel/userDetail",
        updatedUserList
      );
      alertSuccess(
        response?.data?.success || "User data updated successfully!"
      );
      return response.data;
    } catch (error) {
      alertError(
        error?.response?.data?.errors || "Error in updating user list update"
      );
      return rejectWithValue(error.response?.data?.errors || error.message);
    }
  }
);

// Async thunk to fetch user types
export const fetchUserType = createAsyncThunk(
  "userList/fetchUserType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/account/panel/userType");
      return response.data; // Modify based on your API response structure
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "userList/getUserProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/profile/panel/profile");
      return response.data.result; // Modify based on your API response structure
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const userListSlice = createSlice({
  name: "userList",
  initialState: {
    users: [],
    userTypes: [], // New state for user types
    userProfile: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload;
      })
      .addCase(fetchUserList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // update user list
      .addCase(updateUserList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateUserList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(updateUserList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(fetchUserType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.userTypes = action.payload; // Store user types in the state
      })
      .addCase(fetchUserType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getUserProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.userProfile = action.payload; // Store user types in the state
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default userListSlice.reducer;
